module.exports = __webpack_public_path__ + "img/ape-constructor-info.dc245741.svg";